import React from "react";

const Mouse = () => {
  return (
    <div id="rs-mouse">
      <div id="cursor-ball"></div>
    </div>
  );
};

export default Mouse;
